import { useContractsQueryLegacy } from '@/src/api';
import { useAccountContext } from '@ovotech/ui-tools';
import { EnergyContract } from '@/src/types/Account';
import { getActiveContracts } from '@/src/utils/contracts';

type TariffType = 'mixed' | 'fixed' | 'variable' | 'half-hourly' | null;

const getTariffType = (
  elec: EnergyContract[],
  gas: EnergyContract[],
): TariffType => {
  const activeElecContracts = getActiveContracts(elec);
  const activeGasContracts = getActiveContracts(gas);

  if (activeElecContracts.length === 0 && activeGasContracts.length === 0) {
    return null;
  }

  const elecType = activeElecContracts.reduce<
    'fixed' | 'variable' | 'half-hourly' | null
  >((_acc, { type }) => type, null);

  const gasType = activeGasContracts.reduce<
    'fixed' | 'variable' | 'half-hourly' | null
  >((_acc, { type }) => type, null);

  if (elecType && gasType) {
    return elecType === gasType ? elecType : 'mixed';
  }

  return elecType || gasType;
};

export const useTariffType = (): {
  isLoading: boolean;
  tariffType: TariffType;
} => {
  const { accountId } = useAccountContext();
  const { isLoading, isSuccess, data } = useContractsQueryLegacy(accountId, {
    retry: false,
  });

  if (isSuccess && data) {
    const tariffType = data ? getTariffType(data.electricity, data.gas) : null;

    return { isLoading, tariffType };
  }

  return { isLoading, tariffType: null };
};
